import { cn } from '@/lib/utils';

const H5 = ({
    variant = 'default',
    color = 'black',
    className,
    ...props
}: React.HTMLAttributes<HTMLHeadingElement> & {
    variant?: 'default';
    color?: 'black' | 'inherit';
}) => {
    const variantClasses = {
        default:
            'lg:text-[18px] text-[16px] 2xl:text-[18px] pressura uppercase inline-block leading-[120%]',
    };

    const colorClasses = {
        black: 'text-black',
        inherit: 'text-inherit',
    };

    return (
        <h5
            className={cn(
                variantClasses[variant],
                colorClasses[color],
                className,
            )}
            {...props}
        />
    );
};

H5.displayName = 'H5';

export default H5;
